import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-4_chuchai_no",
  "use": "icon-4_chuchai_no-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-4_chuchai_no\">\n<path d=\"M9 29.5C9 28.6716 9.67157 28 10.5 28H29.5C30.3284 28 31 28.6716 31 29.5V29.5C31 30.3284 30.3284 31 29.5 31H10.5C9.67157 31 9 30.3284 9 29.5V29.5Z\" fill=\"#BBD0EA\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.6795 15.8297L25.3392 13.0075C27.1749 11.8957 29.4645 11.849 31.344 12.885L32.8656 13.7238C33.4274 14.0335 33.4146 14.8452 32.8433 15.1369L12.01 25.7752C11.2793 26.1483 10.3949 26.0374 9.77907 25.4953L6.1404 22.293C5.88362 22.067 5.9245 21.6557 6.22074 21.4846L6.78424 21.1593C7.27265 20.8773 7.87794 20.8931 8.35097 21.2002L10.0216 22.2846L15.1661 19.1688L9.83382 12.5587C9.60255 12.272 9.68181 11.8465 10.0008 11.6624L10.7043 11.2562C11.3212 10.9 12.0811 10.8989 12.6992 11.2533L20.6795 15.8297Z\" fill=\"#BBD0EA\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/4_chuchai_no.svg
// module id = ZX2D
// module chunks = 45